import { useState } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { useMaskedInputProps } from 'react-native-mask-input';

import { FormControlTextInput } from '../form-control-text-input';
import { IconMobile } from '../icon';

import { loginPhoneNumberMask } from './masks';

import { MaskInputProps } from '.';

export const PHONE_INPUT_ACCESSORY_ID = 'phoneNumberMaskedInput';

export function PhoneNumberMaskInput(props: MaskInputProps) {
  const [maskedPhoneNumber, setMaskedPhoneNumber] = useState(props.value);
  const DEFAULT_PHONE = '(000) 000-0000';

  const { onChangeText, value: maskedValue } = useMaskedInputProps({
    value: maskedPhoneNumber,
    onChangeText: (masked, _unmasked) => {
      setMaskedPhoneNumber(masked);
      props.onChange(_unmasked);
    },
    mask: loginPhoneNumberMask,
  });

  // Force VoiceOver to read each digit individually instead of as a whole number.
  const spokenDigits = maskedValue.replace(/\D/g, '').split('').join(' ');

  return (
    <FormControlTextInput
      style={styles.input}
      labelStyle={{ marginRight: 'auto' }}
      autoFocus={props.autoFocus}
      error={props.error}
      label={props.label}
      placeholder={DEFAULT_PHONE}
      keyboardType="number-pad"
      readOnly={props.readOnly}
      leftIcon={<IconMobile size={24} />}
      onChangeText={onChangeText}
      value={maskedValue}
      accessibilityValue={spokenDigits ? { text: spokenDigits } : undefined}
      inputAccessoryViewID={PHONE_INPUT_ACCESSORY_ID}
      onBlur={props.onBlur}
      onSubmitEditing={props.onSubmitEditing}
      required={props.required}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    maxHeight: 48,
    width: '100%',
    ...Platform.select({
      web: {
        flex: 1,
      },
      default: {
        flex: 0,
      },
    }),
  },
});
